import { useCallback, useEffect, useState } from 'react';

export const DESKTOP_SIDEBAR_STORAGE_KEY = 'd-cards:desktop-sidebar:collapsed';

type SidebarStorage = Pick<Storage, 'getItem' | 'setItem'>;

function browserStorage(): SidebarStorage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readDesktopSidebarCollapsed(
  storage: SidebarStorage | null = browserStorage(),
): boolean {
  try {
    return storage?.getItem(DESKTOP_SIDEBAR_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeDesktopSidebarCollapsed(
  collapsed: boolean,
  storage: SidebarStorage | null = browserStorage(),
): void {
  try {
    storage?.setItem(DESKTOP_SIDEBAR_STORAGE_KEY, collapsed ? 'true' : 'false');
  } catch {}
}

export function useDesktopSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(readDesktopSidebarCollapsed);
  useEffect(() => {
    writeDesktopSidebarCollapsed(collapsed);
  }, [collapsed]);
  const toggle = useCallback(() => setCollapsed((value) => !value), []);
  return { collapsed, toggle };
}
